import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const fadeOut = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`;

export const DialogOverlay = styled.div<{ $isClosing: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${({ $isClosing }) => ($isClosing ? fadeOut : fadeIn)} 0.3s ease-in-out forwards;
`;

export const DialogContent = styled.div`
  position: relative;
  width: 100%;
  max-width: calc(177.77vh - 64px);
  max-height: calc(100vh - 32px);
  aspect-ratio: 16 / 9;
  background: #000;

  @media (max-width: 768px) {
    width: 95vw;
  }
  @media (min-width: 769px) {
    width: 80vw;
  }

  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
`;

export const CloseButton = styled.button`
  position: fixed;
  top: 20px;
  right: 20px;
  background: transparent;
  border: none;
  color: white;
  font-size: 40px;
  cursor: pointer;
  z-index: 100000;
  padding: 10px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    opacity: 0.7;
  }
`;
